import axios from 'axios';
import config from '@/helpers/config';

// The legacy session token the app already holds. SET_TOKEN (user.js) always mirrors
// the vuex token into localStorage, so localStorage is the durable single source; we
// read it here to avoid a circular import of the store into this low-level client.
export function resolveUserToken() {
  const t = localStorage.getItem('user');
  return t !== undefined && t !== null && t !== '' ? t : '';
}

// api-core v2 REST. No `apiKey` header (that's a legacy-PHP credential api-core doesn't
// know); browser auth is the Bearer <userToken> set by the interceptor below (C6).
const apicore = axios.create({
  baseURL: config.apicore.url + '/v2/',
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
});

apicore.interceptors.request.use((cfg) => {
  const token = resolveUserToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = 'Bearer ' + token;
  }
  return cfg;
});

// UTF-8-safe base64url (no '+' '/' '=' — all valid RFC 6455 subprotocol token chars).
function base64url(input) {
  const utf8 = encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, (_, h) => String.fromCharCode(parseInt(h, 16)));
  return window.btoa(utf8).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// R9: browser WS auth rides Sec-WebSocket-Protocol, NEVER a query param — the token
// must never land in a URL, access log, or the browser history. The server echoes
// 'cslobby.lobby.v1' on accept.
export function lobbyProtocols(userToken) {
  return ['cslobby.lobby.v1', 'bearer.' + base64url(userToken || '')];
}

export { apicore };
export default apicore;
